import { render, staticRenderFns } from "./opcionesEnvioCorreo.vue?vue&type=template&id=0896c183"
import script from "./opcionesEnvioCorreo.vue?vue&type=script&lang=js"
export * from "./opcionesEnvioCorreo.vue?vue&type=script&lang=js"
import style0 from "./opcionesEnvioCorreo.vue?vue&type=style&index=0&id=0896c183&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports